import React from 'react';
import { Skeleton } from '@mui/material';
import { ItemWithLabel } from '@innovyze/stylovyze';

interface LabelWithLoadingProps {
	label?: React.ReactNode | string;
	value: React.ReactNode | string;
	loading: boolean;
}

export const LabelWithLoading = ({
	loading,
	...props
}: LabelWithLoadingProps): JSX.Element => {
	const value = loading ? <Skeleton animation="wave" /> : props.value;
	return <ItemWithLabel {...props} value={value} />;
};
